import request from '@/utils/request';

// 登录接口
export const login = (data) => {
    return request.post('/user/login', data);
};

// 注册接口
export function registerApi(data) {
    return request.post('/user/register', data);
}  

// 退出登录接口
export function logoutApi(data) {
  return request.post('/user/logout', data);
} 

// 刷新token接口
export function refreshTokenApi(data) {
  return request.post('/auth/token-refresh', data);
} 

// 发送验证码接口
export function sendVerifyCode(data) {
    return request.post('/security/phone', data);
} 

//发送邮箱验证码
export function sendEmailCode(data) {
    return request.post('/security/email', data);  
}

//忘记密码-修改秘密
export function forgetPassword (username, data) {
  return request.put(`/user/${username}/password`, data);
}

// 对话接口
export function chatMessagesApi(data) {
    return request.post('/pack/chatMessages', data);
} 

// 获取解析内容
export function getSideScreen (data) {
  return request.post('/agent/sideScreen', data);
} 



// 获取会话列表接口
export function conversationsList(params) {
  return request.get('/pack/conversations', {
    params,
  });
} 

// 获取会话历史信息接口
export function messagesInfo(params) {
  return request.get('/pack/messageHistory',{ 
    params,
  });
}

// 置顶会话
export function pinnedConversation(conversationId, data) {
  return request.post(`/pack/messageHistory/${conversationId}`, data);
}

// 重命名会话
export function renameConversation(conversationId, data) {
  return request.post(`/pack/messageHistory/${conversationId}`, data);
}

// 删除会话
export function deleteConversation(conversationId, data) {
  return request.delete(`/pack/messageHistory/${conversationId}`, data);
}

// 游客登录获取token
export const guestLogin = (data) => {
  return request.post('/user/guestLogin', data);
};

// 对话上传文件接口
export const uploadFile = (formData) => {
  return request.post('/pack/uploadFile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    //   'Authorization': 'Bearer app-OlgPmVRTEOQMiDO8f2bxnmcl' // 添加自定义 header
    }
  });
};

//通用文件上传
export const uploadFiles = (formData) => {
  return request.post('/file/files', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
};

//文件下载
export const downloadFile = (fileId) => {
  return request.get(`/file/files/${fileId}`, {
    responseType: 'blob',
  });
};

//文件删除
export const deleteFile = (fileId) => {
  return request.delete(`/api/third_party_apis/${fileId}`);
};

// 获取数据接口
export function fetchData(params) {
  return request.get('/data', { params });
}

// 获取用户信息接口
export function getAccount (params) {
  return request.get('/user/account',{ 
    params,
  });
} 

// 更新用户信息接口
export function updateAccount (data) {
  return request.patch('/user/account', data);
} 

//验证邮箱验证码
export function verifyEmail (email, data) {
  return request.put(`/security/email/${email}`, data);
}

//验证手机验证码
export function verifyPhone (phone, data) {
  return request.put(`/security/phone/${phone}`, data);  
}

// 右边屏：获取初始配置信息V2.0
export function getSideScreenInit (conversation_id, params) {
  return request.get(`/agent/conversation/${conversation_id}/stages`, {
    params,
  });
}

// 右边屏：获取SSE配置信息V2.0
export function getSideScreenSSE (token, data) {
  return request.post('/agent/side-navigation', data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'Pragma': 'no-cache',
      'Priority': 'u=1, i',
    }
  });
}

//终止会话
export function stopChat (data) {
  return request.post('/pack/stopChat', data); 
}

// 第三方配置信息添加接口
export const createThirdPartyAPI = (data) => {
  return request.post('/api/third_party_apis', data);
};

// 第三方配置信息更新接口
export const updateThirdPartyAPI = (id, data) => {
  return request.patch(`/api/third_party_apis/${id}`, data);
};

// 获取第三方配置列表
export function setList(data) {
  return request.post('/api/third_party_apis/query', data);
}

// 创建用户许可
export function creatPermissions (data) {
  return request.post('/user/orders', data);
} 

// 查询产品分类对应标签
export function getCategoryAndTag() {
  return request.get('/category/tags');
}

// 查询中碳在售产品（暂不使用）
export function getFeatures() {
  return request.get('/sale/features');
}

// 查询中碳在售产品（带白名单）
export function getOwnerFeatures() {
  return request.get('/sale/featuresWithWhite');
}

// 查询合作伙伴产品（带白名单）
export function getPartnerProducts() {
  return request.get('/admin/partner/feature',{
    params: {
      page_no: 1,
      page_size: 100,
      disabled: 0,
    },
  });
}

// 搜索产品（暂未接入）
export function searchProducts(data) {
  return request.post('/feature/search', data);
}

// 创建订单
export function creatOrder (data) {
  return request.post('/user/orders', data);
} 

//服务升级-下单
export function upgrade (order_id, data) {
  return request.post(`/user/orders/${order_id}/upgrade`, data);
} 

// 获取用户订单列表
export function getOrderList (params) {
  return request.get('/user/orders',{ 
    params,
  });
} 

// 查看用户许可列表
export function getPermissions (params) {
  return request.get('/user/permissions',{ 
    params,
  });
}

//搜索公司
export function searchCompanies (data) {
  return request.post('/company/companies', data);
}

// 获取公司基本信息
export function getBaseinfo (data) {
  return request.post('/company/companies/baseinfo', data);
}

// 生成合同
export function createContractFile (data) {
  return request.post('/user/contracts/preview', data, {
    responseType: 'blob', // 响应类型为 blob
  });
}

// 生成加购服务合同
export function createContractPreviewFile (order_id, data) {
  return request.post(`/user/orders/${order_id}/upgrade/contracts/preview`, data, {
    responseType: 'blob', // 响应类型为 blob
  });
}

// 下载合同
export function downloadContractFile (id) {
  return request.get(`/user/contracts/${id}`, {
    responseType: 'blob', // 响应类型为 blob
  });
}

//申请试用
export function trial (data) {
  return request.post('/user/permission/trial', data);
}

//取消订单
export function cancelOrder (order_id) {
  return request.post(`/user/orders/${order_id}/cancel`);
}

//申请开票
export function applyInvoice (order_id, data) {
  return request.post(`/user/orders/${order_id}/invoice`, data);
}

//获取自动以UI配置
export function customconfigs (params) {
  return request.get('/customconfigs', { 
    params
  });
}

//获取自定义UI配置
export function getCustomUiConfig (id) {
  return request.get(`/file/json_content/${id}`);
}

// 获取AI助手下一轮问题建议列表
export function suggestedList (id, data) {
  return request.post(`/pack/messages/${id}/suggested`, data);
}

// 获取用户授权码列表
export function getAuthCodeList (params) {
  return request.get('/user/license_codes',{ 
    params,
  });
}

// 删除用户授权码
export function deleteAuthCode (id) {
  return request.delete(`/user/permissions/${id}`);
}

// 查询授权码
export function queryAuthCode (code) {
  return request.get(`/user/license_code/${code}`);
}

// 激活授权码
export function activateCode (code, data) {
  return request.patch(`/user/license_code/${code}/`, data);
}

// 获取数据收集表历史记录
export function getHistoryJsonContent (id) {
  return request.get(`/file/json_content/${id}/versions`);
}

// 获取数据收集表历史记录详情
export function getHistoryJsonContentDetail (id) {
  return request.get(`/file/json_content/${id}/version`);
}

//数据暂存
export function saveVersion (id, data) {
  return request.post(`/file/json_content/${id}/version`, data);
}

// 提交反馈
export function sendFeedbackApi (id, data) {
  return request.post(`/pack/messages/${id}/feedback`, data);
}

// 获取知识库列表数据
export function getKnowledge (user_id) {
  return request.get(`/user/user_knowledge_base?user_id=${user_id}`);
}

// 上传知识库，保存知识库
export function postKnowledge(data) {
  return request.post(`/user/user_knowledge_base/upload`, data)
}

// 获取方案列表
export function getPlanList(params) {
  return request.get('/user/conversation_plan', {
    params
  });
}

// 获取知识库分类和标签数据
export function getKnowledgeBaseCategoryAndTag() {
  return request.get('/user/KnowledgeTags');
}

// 获取知识库列表数据（可传入 axios 配置，将 tag_search 按 JSON 二维数组传递）
export function getKnowledgeBaseList(params, axiosConfig = {}) {
  return request.get('/user/KnowledgeFiles', {
    params,
    ...axiosConfig
  });
}

// 下载知识库文件（获取minio文件地址）
export function getMinioFileUrl(object_name) {
  return request.get(`/user/getKnowledgeFileLink/${object_name}`);
}

// 获取知识库预览文件
export function getKnowledgeFilePreview(knowledge_id) {
  return request.get(`/user/knowledge/${knowledge_id}/preview`, {
    responseType: 'blob',
  });
}

// 获取数据收集表地址
export function getDownloadUrl(json_content_version_id) {
  return request.get(`/file/json_content/${json_content_version_id}/download`);
}

// 删除数据收集表记录
export function deleteDownloadUrl(json_content_version_id) {
  return request.delete(`/file/json_content/${json_content_version_id}`);
}

// 复制分享链接  /user/conversation/share/{share_code}
export function postCopyShareLink(data) {
  return request.post(`/user/conversation/share`, data)
}

// 获取分享码
export function getShareCode(share_code) {
  return request.get(`/user/conversation/share/${share_code}`);
}

// 站内信未读数量
export function getNoticeUnreadCount() {
  return request.get('/v1/messages/unread-count');
}

// 站内信列表
export function getNoticeList(params) {
  return request.get('/v1/messages', {
    params
  });
}

// 站内信已读
export function readNotice(id, data) {
  return request.put(`/v1/messages/${id}/`, data);
}

// 站内信删除
export function deleteNotice(id) {
  return request.delete(`/v1/messages/${id}`);
}


// 交通查询助手：查询铁路、航空间里程（单位:公里）
export function getRailAndAirDistance(headers, body) {
  return request.post('/pack/station-mileages/query', body, { headers });
}

// 交通查询助手：查询地铁间里程（单位:米）
export function getSubwayDistance(headers, body) {
  return request.post('/pack/MetroDistance', body, { headers });
}

// 交通查询助手：查询铁路、航空、地铁站点(way: 'RAIL' | 'AIR' | 'METRO')
export function getStationInfo(way) {
  return request.get('/user/stations', { params: { way } });
}

// 获取碳盘查问卷
export function getTpcQuestionnaire(id) {
  return request.get(`/file/conversationCard/${id}`);
}

// 更新碳盘查问卷
export function putTpcQuestionnaire(id, data) {
  return request.put(`/file/conversationCard/${id}`, data);
}